"use strict";var hasOwnProperty={}.hasOwnProperty;module.exports=function(r,t){return hasOwnProperty.call(r,t)};